<section class="intro-{{'id' | translate}} bg-img" id="intro">
  <article class="intro-bottom-bg absolute full-width bottom-0 left-0">
    <div class="content-wrap full-height"></div>
  </article>
  <article class="intro-promo-wrap">
    <div class="content-wrap flex row wrap space-between">
      <div class="intro-promo relative-right full-width txt-center grow-3">
        <div class="lotto-box padding-15 margin-top-15">
          <div class="square-box relative margin-auto padding-left-right-25">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    </div>
  </article>
</section>
<section class="intro-baseline" *ngIf="lottoId == 11">
  <a href="#picker">
    <h2>Sorteio especial da Mega da Virada do dia 31 de Dezembro.</h2>
  </a>
</section>
